const DestinazioneFattura = Object.freeze({
  SDI: "SDI",
  STS: "STS",
});

export default DestinazioneFattura;
